// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/common/v1/tag_filter.proto (package chalk.common.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/common/v1/tag_filter.proto.
 */
export const file_chalk_common_v1_tag_filter: GenFile = /*@__PURE__*/
  fileDesc("CiBjaGFsay9jb21tb24vdjEvdGFnX2ZpbHRlci5wcm90bxIPY2hhbGsuY29tbW9uLnYxIucBCglUYWdGaWx0ZXISLAoEdGFncxgBIAMoCzIeLmNoYWxrLmNvbW1vbi52MS5UYWdGaWx0ZXIuVGFnEjgKCm1hdGNoX21vZGUYAiABKA4yJC5jaGFsay5jb21tb24udjEuVGFnRmlsdGVyLk1hdGNoTW9kZRohCgNUYWcSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJIk8KCU1hdGNoTW9kZRIaChZNQVRDSF9NT0RFX1VOU1BFQ0lGSUVEEAASEgoOTUFUQ0hfTU9ERV9BTEwQARISCg5NQVRDSF9NT0RFX0FOWRACYgZwcm90bzM");

/**
 * Exact, case-sensitive key/value matching against an object's tags.
 * Absent filters and empty tag lists impose no restriction.
 *
 * @generated from message chalk.common.v1.TagFilter
 */
export type TagFilter = Message<"chalk.common.v1.TagFilter"> & {
  /**
   * Repeated pairs allow ANY to match multiple values for the same key.
   *
   * @generated from field: repeated chalk.common.v1.TagFilter.Tag tags = 1;
   */
  tags: TagFilter_Tag[];

  /**
   * @generated from field: chalk.common.v1.TagFilter.MatchMode match_mode = 2;
   */
  matchMode: TagFilter_MatchMode;
};

/**
 * Describes the message chalk.common.v1.TagFilter.
 * Use `create(TagFilterSchema)` to create a new message.
 */
export const TagFilterSchema: GenMessage<TagFilter> = /*@__PURE__*/
  messageDesc(file_chalk_common_v1_tag_filter, 0);

/**
 * @generated from message chalk.common.v1.TagFilter.Tag
 */
export type TagFilter_Tag = Message<"chalk.common.v1.TagFilter.Tag"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message chalk.common.v1.TagFilter.Tag.
 * Use `create(TagFilter_TagSchema)` to create a new message.
 */
export const TagFilter_TagSchema: GenMessage<TagFilter_Tag> = /*@__PURE__*/
  messageDesc(file_chalk_common_v1_tag_filter, 0, 0);

/**
 * @generated from enum chalk.common.v1.TagFilter.MatchMode
 */
export enum TagFilter_MatchMode {
  /**
   * Same behavior as ALL.
   *
   * @generated from enum value: MATCH_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MATCH_MODE_ALL = 1;
   */
  ALL = 1,

  /**
   * @generated from enum value: MATCH_MODE_ANY = 2;
   */
  ANY = 2,
}

/**
 * Describes the enum chalk.common.v1.TagFilter.MatchMode.
 */
export const TagFilter_MatchModeSchema: GenEnum<TagFilter_MatchMode> = /*@__PURE__*/
  enumDesc(file_chalk_common_v1_tag_filter, 0, 0);
